const data = [
	{
		id: 1,
		headline: "Select your best menus",
		desc:
			"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut."
	},
	{
		id: 2,
		headline: "Complete the payment",
		desc:
			"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore."
	},
	{
		id: 3,
		headline: "Complete the payment",
		desc:
			"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
	}
];
export default data;
